import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonButton, IonButtons, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonSearchbar, IonTitle, IonToolbar, ModalController } from '@ionic/angular/standalone';
import { LetDirective } from '@ngrx/component';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { InformativeComponent } from 'src/app/components/informative/informative.component';
import { ItemComponent } from 'src/app/components/item/item.component';
import { SpinnerComponent } from 'src/app/components/spinner/spinner.component';
import { NavigableDirective } from 'src/app/directives/navigable.directive';
import { ImagingModalityBodyPart } from 'src/app/services/body-parts.service';
import { appendResultsRequested, newSearchRequested, resultsCleared } from 'src/app/store/body-parts-search/body-parts-search.actions';
import { morePagesExist, newSearchInProgress, queryTerm, searchResults } from 'src/app/store/body-parts-search/body-parts-search.selectors';
import { AppState } from 'src/app/store/reducers';

@Component({
	templateUrl: './body-parts-search.modal.html',
	styleUrl: './body-parts-search.modal.scss',
	imports: [
		LetDirective, IonHeader, IonToolbar, IonTitle, IonButtons, IonButton, IonIcon, IonSearchbar, IonInfiniteScroll, IonInfiniteScrollContent,
		ItemComponent, SpinnerComponent, InformativeComponent, NavigableDirective
	],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class BodyPartsSearchModal implements OnInit {

	@Input() modality!: string;
	@Input() modalityText!: string;
	@ViewChild(IonSearchbar, { static: false }) searchbar!: IonSearchbar;
	@ViewChild(IonInfiniteScroll, { static: false }) infiniteScroll!: IonInfiniteScroll;

	queryTerm$: Observable<string>;
	newSearchInProgress$: Observable<boolean>;
	searchResults$: Observable<ImagingModalityBodyPart[]>;
	morePagesExist$: Observable<boolean>;

	get searchbarPlaceholder() { return `Search '${this.modalityText}' body regions` }

	constructor(private modalController: ModalController, private store: Store<AppState>) {
		this.queryTerm$ = this.store.pipe(select(queryTerm));
		this.newSearchInProgress$ = this.store.pipe(select(newSearchInProgress));
		this.searchResults$ = this.store.pipe(select(searchResults)).pipe(tap(() => { if (this.infiniteScroll) this.infiniteScroll.complete() }));
		this.morePagesExist$ = this.store.pipe(select(morePagesExist));
	}

	ngOnInit() {
		setTimeout(() => this.searchbar.setFocus(), 500);
	}

	queryTermChanged(event: Event) {
		const queryTerm = (event as CustomEvent).detail.value.trim();
		if (queryTerm) {
			this.store.dispatch(newSearchRequested({ queryTerm: queryTerm, modality: this.modality }));
		}
		else {
			this.store.dispatch(resultsCleared());
		}
	}

	appendResults() {
		this.store.dispatch(appendResultsRequested());
	}

	close() {
		this.store.dispatch(resultsCleared());
		this.modalController.dismiss();
	}

	async bodyPartSelected(bodyPart: ImagingModalityBodyPart) {
		await this.modalController.dismiss({ bodyPart: bodyPart });
		this.store.dispatch(resultsCleared());
	}
}